import { render, staticRenderFns } from "./quanxian.vue?vue&type=template&id=797bc926&scoped=true"
import script from "./quanxian.vue?vue&type=script&lang=js"
export * from "./quanxian.vue?vue&type=script&lang=js"
import style0 from "./quanxian.vue?vue&type=style&index=0&id=797bc926&prod&lang=scss&scoped=true"
import style1 from "./quanxian.vue?vue&type=style&index=1&id=797bc926&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797bc926",
  null
  
)

export default component.exports